import { Box, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { MarkdownView } from 'src/common/components/markdown-editor/MarkdownView';
import { LoadingAnimation } from '../chat/components/LoadingAnimation';
import { camelCaseOrSnakeCaseToWords } from 'src/data-capture/merge-review/ReviewHelperFunctions';
import { VerifyResult } from '../chat/verify/VerifyResult';
import { VerifyEvidence, VerifyOutcome } from '../chat/verify/types';
import { ThinkingTile } from './ThinkingTile';

type Props = {
  content: string;
  thinkingContent?: string;
  isThinking?: boolean;
  currentState?: string;
  currentToolName?: string;
  retryNotice?: string;
  dark?: boolean;
  verifyOutcome?: VerifyOutcome;
  evidence?: VerifyEvidence[];
  verifyMeetingNoteId?: string;
  verifyNote?: string;
  onVerifyAction?: (outcome: VerifyOutcome, note?: string) => void;
};

export function SiestaMessage({
  content,
  thinkingContent,
  isThinking,
  currentState,
  currentToolName,
  retryNotice,
  dark,
  verifyOutcome,
  evidence,
  verifyMeetingNoteId,
  verifyNote,
  onVerifyAction,
}: Props) {
  const statusLabel =
    currentToolName || (currentState && camelCaseOrSnakeCaseToWords(currentState));

  return (
    <Box>
      {retryNotice ? (
        <Flex justify="start" align="center" gap="xs" mb="xs">
          <LoadingAnimation />
          <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="orange.7">
            {retryNotice}
          </Text>
        </Flex>
      ) : (
        isThinking &&
        statusLabel && (
          <>
            <Flex justify="start" align="center" mb="xs">
              <LoadingAnimation />
            </Flex>
            <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="orange.7">
              {currentToolName || `${statusLabel}...`}
            </Text>
          </>
        )
      )}
      {thinkingContent && <ThinkingTile content={thinkingContent} />}
      {verifyOutcome ? (
        <VerifyResult
          outcome={verifyOutcome}
          evidence={evidence ?? []}
          meetingNoteId={verifyMeetingNoteId}
          note={verifyNote}
          dark={dark}
          onAction={() => onVerifyAction?.(verifyOutcome, verifyNote)}
        />
      ) : (
        <Box
          fz="var(--mantine-font-size-textSm)"
          fw={FONT_WEIGHTS.medium}
          c={dark ? 'white' : 'gray.8'}
        >
          <MarkdownView value={content} />
        </Box>
      )}
    </Box>
  );
}
